import { render, staticRenderFns } from "./BaseBtn.vue?vue&type=template&id=079977c7&scoped=true&"
import script from "./BaseBtn.vue?vue&type=script&lang=js&"
export * from "./BaseBtn.vue?vue&type=script&lang=js&"
import style0 from "./BaseBtn.vue?vue&type=style&index=0&id=079977c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079977c7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
